import {
    AvatarProps,
    Box,
    Button,
    Input,
    Menu,
    MenuList,
    Skeleton,
} from '@chakra-ui/react'
import React, { useMemo, useState } from 'react'
import AssigneeButton from '~components/pending-actions/pending-item-rows/assignee-select/assignee-button'
import AssigneeItem from '~components/pending-actions/pending-item-rows/assignee-select/assignee-item'
import { UserBasicInfoFragment } from '~graphql/generated/graphql'

interface Props extends AvatarProps {
    assignee: UserBasicInfoFragment | null
    setAssignee: (assignee: UserBasicInfoFragment | null) => void
    userOptions: UserBasicInfoFragment[]
    overrideButton?: React.ReactNode
    isLoading?: boolean
}

export default function SharedAssigneeSelect({
    assignee,
    setAssignee,
    userOptions,
    isLoading,
    overrideButton,
    ...rest
}: Props) {
    const [search, setSearch] = useState('')

    const filteredUserOptions = useMemo(
        () =>
            userOptions.filter(user =>
                `${user.first_name} ${user.last_name}`
                    .toLowerCase()
                    .includes(search.toLowerCase()),
            ),
        [userOptions, search],
    )

    return (
        <Skeleton isLoaded={!isLoading} rounded="full">
            <Menu isLazy>
                {overrideButton || (
                    <AssigneeButton assignee={assignee} {...rest} />
                )}
                <MenuList
                    maxH="296px"
                    overflowY="auto"
                    position="relative"
                    pt={0}
                    mt={0}
                >
                    <Box
                        p={2}
                        position="sticky"
                        top={0}
                        bg="white"
                        zIndex={1}
                        borderBottom="1px solid"
                        borderColor="gray.200"
                    >
                        <Input
                            autoFocus
                            size="sm"
                            placeholder="Search users..."
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            onBlur={e => {
                                e.target.focus()
                            }}
                        />
                    </Box>
                    <AssigneeItem onSelect={() => setAssignee(null)} />
                    {filteredUserOptions.map(user => (
                        <AssigneeItem
                            key={user.id}
                            user={user}
                            onSelect={() => setAssignee(user)}
                        />
                    ))}
                </MenuList>
            </Menu>
        </Skeleton>
    )
}
